class ProviderStatusChangedSystemNotificationPayload {
  constructor(systemNotificationPayloadData = {}) {
    this.benefitName = systemNotificationPayloadData.benefit_name || "";
  }
}

export default ProviderStatusChangedSystemNotificationPayload;
